import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionPillar from "@/pages/SolutionPillar";

export const Route = createFileRoute("/en/solutions/$pillarSlug")({
  head: ({ params }) => buildRouteHead(`/en/solutions/${params.pillarSlug}`),
  component: SolutionPillar,
});

